import { type AggregationFn } from "@tanstack/react-table";

export const unique: AggregationFn<unknown> = (columnId, leafRows) => {
	return new Set(leafRows.map((d) => d.getValue(columnId))).size;
};
